exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroller[data-v-73da61b2]{color:#ff3232;position:absolute;bottom:25px;text-align:center;cursor:pointer}.scroller .material-icons[data-v-73da61b2]{font-size:4em;position:relative;-webkit-animation:pulse 1.3s infinite;animation:pulse 1.3s infinite}footer[data-v-73da61b2]{margin-top:2em;padding:1.75em;text-align:center;background-color:#ff3232}footer p[data-v-73da61b2]{margin:0;font-size:1em;color:#fff;font-weight:300}footer p .material-icons[data-v-73da61b2]{top:2px;position:relative;font-size:1em}footer p a[data-v-73da61b2]{color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-73da61b2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./app/Application.vue
// module id = 24
// module chunks = 0